import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1827.70109 0L960.065275 867.63582 92.2989053 0 0 92.1683552 867.63582 959.934725 0 1827.57054 92.2989053 1920 960.065275 1052.23363 1827.70109 1920 1919.86945 1827.57054 1052.23363 959.934725 1919.86945 92.1683552z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDiscussionXLine = /*#__PURE__*/function (_Component) {
  _inherits(IconDiscussionXLine, _Component);

  var _super = _createSuper(IconDiscussionXLine);

  function IconDiscussionXLine() {
    _classCallCheck(this, IconDiscussionXLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconDiscussionXLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconDiscussionXLine /> is deprecated. Please use <IconXLine /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDiscussionX",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDiscussionXLine.displayName = "IconDiscussionXLine";
  return IconDiscussionXLine;
}(Component);

IconDiscussionXLine.glyphName = 'discussion-x';
IconDiscussionXLine.variant = 'Line';
IconDiscussionXLine.deprecated = true;
IconDiscussionXLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDiscussionXLine;
export { IconDiscussionXLine };